<template>
    <div class="line">
        <ul :class="{
            'text-right':line.length == 5,
            'text-center':line.length < 5
            }">
            <li v-for="(item,i) in line" :key="i" @click="selectIndex = i">
                <a target="_blank" :href="item">
                    <img class="line2" v-if="selectIndex == i" src="../assets/images/line7.png" />
                    <img class="line1" v-else src="../assets/images/line5.png" />
                    <span>游戏入口-{{NUm[i]}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectIndex: 0,
            NUm:[
                '①',
                '②',
                '③',
                '④',
                '⑤',
            ]
        }
    },
    props:['line'],
    created(){
        setInterval(()=>{
            this.selectIndex = (++this.selectIndex) % this.line.length
        },3000)
    }
}
</script>

<style scoped>
ul {
    margin-top: -45px;
    text-align: left;
    margin-left: 245px;
}

li {
    list-style-type: none;
    color: #fff;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 22px;
    /* margin-left: 16px; */
}

.line1 {}

.line2 {
    /* width: 169px; */
}

li span {
    position: absolute;
    right: 45px;
    top: 16px;
    color: #fff;
    font-size: 20px;
    
}
</style>



// WEBPACK FOOTER //
// src/components/a.header.line.vue